// extracted by mini-css-extract-plugin
export default {"wrapper":"Forms_wrapper__f69sP","form":"Forms_form__WyCGc","input":"Forms_input__BqPOp","message":"Forms_message__mLeWn","text":"Forms_text__H+-Fg","heading":"Forms_heading__mLleX"};